import { timestamp_to_date } from '@/utils/time'
import { z } from 'zod'


export const RoleSchema = z.object({
  id: z.number(),
  name: z.string(),
  is_enabled: z.union([z.boolean(), z.null(), z.undefined()]).optional()
});

export const userSchema = z.object({
  id: z.string(),
  name: z.string(),
  username: z.string().nullable(),
  email: z.string().nullable(),
  is_active: z.boolean(),
  role: RoleSchema,
  is_admin: z.boolean(),
  created_at: z.number().transform(timestamp_to_date)
})

export const userInfoSchema = userSchema.extend({
  active_cases: z.number().optional(),
  coming_rendezvous: z.number().optional()
})

export type User = z.infer<typeof userSchema>
export type UserInfo = z.infer<typeof userInfoSchema>
export type Role = z.infer<typeof RoleSchema>

export const userListSchema = z.array(userSchema)
